// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleIntegrationsManager = {
  id: "integrations-manager",
  mrn: "//iam.api.mondoo.app/roles/integrations-manager",
  title: "Integrations Manager",
  allowedActions,
} as const;

export type RoleIntegrationsManager = typeof roleIntegrationsManager;
